// src/pages/terms/PrivacyNotice.jsx

import { Link } from "react-router-dom";
import Hero from "../../components/Hero";
import "./PrivacyNotice.css";

export default function PrivacyNotice() {
  return (
    <>
      {/* Hero banner */}
      <Hero
        title="Privacy Notice"
        // subtitle="Your privacy is important to us"
        mediaType="image"
        mediaSrc="" // swap in your own image/video
      />

      {/* Main policy content */}
      <main className="privacy-content container">
        <p className="privacy-content__date">
          <strong>Effective Date:</strong> 6.23.2025
        </p>

        <p>
          Welcome to the official website of George Sotirov. Your privacy is
          important, and this Privacy Policy outlines how we collect, use, and
          protect any information gathered from visitors.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We do not collect any personally identifiable information (such as
          name, email, or contact details). The only data collected is anonymous
          usage data — specifically:
        </p>
        <ul>
          <li>The number of visitors to the site</li>
          <li>General usage patterns (e.g., page views, time spent)</li>
        </ul>
        <p>
          This is done through a basic analytics tool to help understand website
          traffic and improve the user experience.
        </p>

        <h2>2. Use of Collected Information</h2>
        <p>The anonymous data collected is used solely for:</p>
        <ul>
          <li>Monitoring site performance</li>
          <li>Understanding general visitor engagement</li>
          <li>Making improvements to design and content</li>
        </ul>
        <p className="privacy-content__highlight">
          This data is <em>not</em> used for advertising, profiling, or shared
          with third parties.
        </p>

        <h2>3. Cookies</h2>
        <p>
          This website may use minimal cookies related to visitor analytics.
          These cookies do not collect personal information.
        </p>
        <p>
          You can disable cookies in your browser settings at any time without
          affecting your ability to browse the site.
        </p>

        <h2>4. Third-Party Services</h2>
        <p>
          If basic analytics (e.g., Google Analytics or Plausible Analytics) is
          used, it complies with GDPR and similar regulations. All data remains
          anonymous and is used for aggregate insights only.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          As a visitor from the EU or other privacy-conscious regions, you have
          the right to:
        </p>
        <ul>
          <li>
            Request information about any personal data collected (note: we
            don’t collect any)
          </li>
          <li>
            Request deletion of data (if any were ever stored, which they are
            not)
          </li>
        </ul>

        <h2>6. Contact</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, feel
          free to reach out via the{" "}
          <Link to="/contact" className="privacy-link">
            Contact Page
          </Link>{" "}
          or email at{" "}
          <a href="mailto:gsotirovapm@gmail.com" className="privacy-link">
            gsotirovapm@gmail.com
          </a>
          ,{" "}
          <a href="mailto:contact@georgesotirov.com" className="privacy-link">
            contact@georgesotirov.com
          </a>
          .
        </p>

        <h2>7. Updates</h2>
        <p>
          This Privacy Policy may be updated from time to time. The latest
          version will always be available on this page.
        </p>
      </main>

      {/* Site footer */}
    </>
  );
}
